/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddCustomerCreditsRequestBody,
  GetOfferDescriptionResponse,
  GetSubscriptionStatusResponse,
  RestoreSubscriptionRequestBody,
  SubscriptionControllerRunJob200Response,
  UpdatePaymentMethodRequest,
  UpdateTrialPeriodRequestBody,
} from '../models/index';
import {
    AddCustomerCreditsRequestBodyFromJSON,
    AddCustomerCreditsRequestBodyToJSON,
    GetOfferDescriptionResponseFromJSON,
    GetOfferDescriptionResponseToJSON,
    GetSubscriptionStatusResponseFromJSON,
    GetSubscriptionStatusResponseToJSON,
    RestoreSubscriptionRequestBodyFromJSON,
    RestoreSubscriptionRequestBodyToJSON,
    SubscriptionControllerRunJob200ResponseFromJSON,
    SubscriptionControllerRunJob200ResponseToJSON,
    UpdatePaymentMethodRequestFromJSON,
    UpdatePaymentMethodRequestToJSON,
    UpdateTrialPeriodRequestBodyFromJSON,
    UpdateTrialPeriodRequestBodyToJSON,
} from '../models/index';

export interface SubscriptionControllerAdminAbortSubscriptionCancellationRequest {
    userId: string;
}

export interface SubscriptionControllerAdminAddCreditsToCustomerRequest {
    userId: string;
    addCustomerCreditsRequestBody: AddCustomerCreditsRequestBody;
}

export interface SubscriptionControllerAdminCancelSubscriptionRequest {
    userId: string;
}

export interface SubscriptionControllerAdminCancelSubscriptionAtPeriodEndRequest {
    userId: string;
}

export interface SubscriptionControllerAdminDeleteUserSubscriptionCancellationRequest {
    userId: string;
    restoreSubscriptionRequestBody: RestoreSubscriptionRequestBody;
}

export interface SubscriptionControllerAdminMakeSubscriptionFreeRequest {
    userId: string;
}

export interface SubscriptionControllerAdminMakeSubscriptionPaidRequest {
    userId: string;
}

export interface SubscriptionControllerAdminRefundInvoiceRequest {
    userId: string;
    invoiceId: string;
}

export interface SubscriptionControllerAdminUpdateTrialDaysRequest {
    userId: string;
    updateTrialPeriodRequestBody: UpdateTrialPeriodRequestBody;
}

export interface SubscriptionControllerAdminVoidInvoiceRequest {
    userId: string;
    invoiceId: string;
}

export interface SubscriptionControllerGetSubscriptionStatusRequest {
    userId: string;
    forceRefresh?: boolean;
}

export interface SubscriptionControllerLegacyAdminCancelSubscriptionRequest {
    userId: string;
}

export interface SubscriptionControllerLegacyGetSubscriptionStatusRequest {
    userId: string;
    forceRefresh?: boolean;
}

export interface SubscriptionControllerRunJobRequest {
    jobName: SubscriptionControllerRunJobJobNameEnum;
}

export interface SubscriptionControllerUpdatePaymentMethodRequest {
    updatePaymentMethodRequest: UpdatePaymentMethodRequest;
}

export interface SubscriptionWebHookControllerStripeWebhookRequest {
    stripeSignature: string;
}

/**
 * SubscriptionApi - interface
 * 
 * @export
 * @interface SubscriptionApiInterface
 */
export interface SubscriptionApiInterface {
    /**
     * 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApiInterface
     */
    subscriptionControllerAdminAbortSubscriptionCancellationRaw(requestParameters: SubscriptionControllerAdminAbortSubscriptionCancellationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    subscriptionControllerAdminAbortSubscriptionCancellation(requestParameters: SubscriptionControllerAdminAbortSubscriptionCancellationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} userId 
     * @param {AddCustomerCreditsRequestBody} addCustomerCreditsRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApiInterface
     */
    subscriptionControllerAdminAddCreditsToCustomerRaw(requestParameters: SubscriptionControllerAdminAddCreditsToCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    subscriptionControllerAdminAddCreditsToCustomer(requestParameters: SubscriptionControllerAdminAddCreditsToCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApiInterface
     */
    subscriptionControllerAdminCancelSubscriptionRaw(requestParameters: SubscriptionControllerAdminCancelSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    subscriptionControllerAdminCancelSubscription(requestParameters: SubscriptionControllerAdminCancelSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApiInterface
     */
    subscriptionControllerAdminCancelSubscriptionAtPeriodEndRaw(requestParameters: SubscriptionControllerAdminCancelSubscriptionAtPeriodEndRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    subscriptionControllerAdminCancelSubscriptionAtPeriodEnd(requestParameters: SubscriptionControllerAdminCancelSubscriptionAtPeriodEndRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} userId 
     * @param {RestoreSubscriptionRequestBody} restoreSubscriptionRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApiInterface
     */
    subscriptionControllerAdminDeleteUserSubscriptionCancellationRaw(requestParameters: SubscriptionControllerAdminDeleteUserSubscriptionCancellationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    subscriptionControllerAdminDeleteUserSubscriptionCancellation(requestParameters: SubscriptionControllerAdminDeleteUserSubscriptionCancellationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApiInterface
     */
    subscriptionControllerAdminMakeSubscriptionFreeRaw(requestParameters: SubscriptionControllerAdminMakeSubscriptionFreeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    subscriptionControllerAdminMakeSubscriptionFree(requestParameters: SubscriptionControllerAdminMakeSubscriptionFreeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApiInterface
     */
    subscriptionControllerAdminMakeSubscriptionPaidRaw(requestParameters: SubscriptionControllerAdminMakeSubscriptionPaidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    subscriptionControllerAdminMakeSubscriptionPaid(requestParameters: SubscriptionControllerAdminMakeSubscriptionPaidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} userId 
     * @param {string} invoiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApiInterface
     */
    subscriptionControllerAdminRefundInvoiceRaw(requestParameters: SubscriptionControllerAdminRefundInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    subscriptionControllerAdminRefundInvoice(requestParameters: SubscriptionControllerAdminRefundInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} userId 
     * @param {UpdateTrialPeriodRequestBody} updateTrialPeriodRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApiInterface
     */
    subscriptionControllerAdminUpdateTrialDaysRaw(requestParameters: SubscriptionControllerAdminUpdateTrialDaysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    subscriptionControllerAdminUpdateTrialDays(requestParameters: SubscriptionControllerAdminUpdateTrialDaysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} userId 
     * @param {string} invoiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApiInterface
     */
    subscriptionControllerAdminVoidInvoiceRaw(requestParameters: SubscriptionControllerAdminVoidInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    subscriptionControllerAdminVoidInvoice(requestParameters: SubscriptionControllerAdminVoidInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApiInterface
     */
    subscriptionControllerCancelMyScheduledCancellationRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    subscriptionControllerCancelMyScheduledCancellation(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApiInterface
     */
    subscriptionControllerCancelMySubscriptionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    subscriptionControllerCancelMySubscription(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApiInterface
     */
    subscriptionControllerDescribeAllOffersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOfferDescriptionResponse>>;

    /**
     */
    subscriptionControllerDescribeAllOffers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOfferDescriptionResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApiInterface
     */
    subscriptionControllerGetJobScheduleRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    subscriptionControllerGetJobSchedule(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} userId 
     * @param {boolean} [forceRefresh] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApiInterface
     */
    subscriptionControllerGetSubscriptionStatusRaw(requestParameters: SubscriptionControllerGetSubscriptionStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSubscriptionStatusResponse>>;

    /**
     */
    subscriptionControllerGetSubscriptionStatus(requestParameters: SubscriptionControllerGetSubscriptionStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSubscriptionStatusResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApiInterface
     */
    subscriptionControllerGetUserSubscriptionStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSubscriptionStatusResponse>>;

    /**
     */
    subscriptionControllerGetUserSubscriptionStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSubscriptionStatusResponse>;

    /**
     * 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApiInterface
     */
    subscriptionControllerLegacyAdminCancelSubscriptionRaw(requestParameters: SubscriptionControllerLegacyAdminCancelSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    subscriptionControllerLegacyAdminCancelSubscription(requestParameters: SubscriptionControllerLegacyAdminCancelSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} userId 
     * @param {boolean} [forceRefresh] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApiInterface
     */
    subscriptionControllerLegacyGetSubscriptionStatusRaw(requestParameters: SubscriptionControllerLegacyGetSubscriptionStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSubscriptionStatusResponse>>;

    /**
     */
    subscriptionControllerLegacyGetSubscriptionStatus(requestParameters: SubscriptionControllerLegacyGetSubscriptionStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSubscriptionStatusResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApiInterface
     */
    subscriptionControllerRestoreMySubscriptionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    subscriptionControllerRestoreMySubscription(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {'sync-subscriptions' | 'notify-trial-about-to-end' | 'notify-overdue-after-trial' | 'expire-subscription-flows'} jobName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApiInterface
     */
    subscriptionControllerRunJobRaw(requestParameters: SubscriptionControllerRunJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubscriptionControllerRunJob200Response>>;

    /**
     */
    subscriptionControllerRunJob(requestParameters: SubscriptionControllerRunJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubscriptionControllerRunJob200Response>;

    /**
     * 
     * @param {UpdatePaymentMethodRequest} updatePaymentMethodRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApiInterface
     */
    subscriptionControllerUpdatePaymentMethodRaw(requestParameters: SubscriptionControllerUpdatePaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    subscriptionControllerUpdatePaymentMethod(requestParameters: SubscriptionControllerUpdatePaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} stripeSignature 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApiInterface
     */
    subscriptionWebHookControllerStripeWebhookRaw(requestParameters: SubscriptionWebHookControllerStripeWebhookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    subscriptionWebHookControllerStripeWebhook(requestParameters: SubscriptionWebHookControllerStripeWebhookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class SubscriptionApi extends runtime.BaseAPI implements SubscriptionApiInterface {

    /**
     */
    async subscriptionControllerAdminAbortSubscriptionCancellationRaw(requestParameters: SubscriptionControllerAdminAbortSubscriptionCancellationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling subscriptionControllerAdminAbortSubscriptionCancellation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/subscription/admin/{userId}/cancel-scheduled-cancellation`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async subscriptionControllerAdminAbortSubscriptionCancellation(requestParameters: SubscriptionControllerAdminAbortSubscriptionCancellationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.subscriptionControllerAdminAbortSubscriptionCancellationRaw(requestParameters, initOverrides);
    }

    /**
     */
    async subscriptionControllerAdminAddCreditsToCustomerRaw(requestParameters: SubscriptionControllerAdminAddCreditsToCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling subscriptionControllerAdminAddCreditsToCustomer().'
            );
        }

        if (requestParameters['addCustomerCreditsRequestBody'] == null) {
            throw new runtime.RequiredError(
                'addCustomerCreditsRequestBody',
                'Required parameter "addCustomerCreditsRequestBody" was null or undefined when calling subscriptionControllerAdminAddCreditsToCustomer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/subscription/admin/{userId}/credits`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddCustomerCreditsRequestBodyToJSON(requestParameters['addCustomerCreditsRequestBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async subscriptionControllerAdminAddCreditsToCustomer(requestParameters: SubscriptionControllerAdminAddCreditsToCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.subscriptionControllerAdminAddCreditsToCustomerRaw(requestParameters, initOverrides);
    }

    /**
     */
    async subscriptionControllerAdminCancelSubscriptionRaw(requestParameters: SubscriptionControllerAdminCancelSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling subscriptionControllerAdminCancelSubscription().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/subscription/admin/{userId}/cancel`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async subscriptionControllerAdminCancelSubscription(requestParameters: SubscriptionControllerAdminCancelSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.subscriptionControllerAdminCancelSubscriptionRaw(requestParameters, initOverrides);
    }

    /**
     */
    async subscriptionControllerAdminCancelSubscriptionAtPeriodEndRaw(requestParameters: SubscriptionControllerAdminCancelSubscriptionAtPeriodEndRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling subscriptionControllerAdminCancelSubscriptionAtPeriodEnd().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/subscription/admin/{userId}/cancel-at-period-end`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async subscriptionControllerAdminCancelSubscriptionAtPeriodEnd(requestParameters: SubscriptionControllerAdminCancelSubscriptionAtPeriodEndRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.subscriptionControllerAdminCancelSubscriptionAtPeriodEndRaw(requestParameters, initOverrides);
    }

    /**
     */
    async subscriptionControllerAdminDeleteUserSubscriptionCancellationRaw(requestParameters: SubscriptionControllerAdminDeleteUserSubscriptionCancellationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling subscriptionControllerAdminDeleteUserSubscriptionCancellation().'
            );
        }

        if (requestParameters['restoreSubscriptionRequestBody'] == null) {
            throw new runtime.RequiredError(
                'restoreSubscriptionRequestBody',
                'Required parameter "restoreSubscriptionRequestBody" was null or undefined when calling subscriptionControllerAdminDeleteUserSubscriptionCancellation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/subscription/admin/{userId}/restore`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RestoreSubscriptionRequestBodyToJSON(requestParameters['restoreSubscriptionRequestBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async subscriptionControllerAdminDeleteUserSubscriptionCancellation(requestParameters: SubscriptionControllerAdminDeleteUserSubscriptionCancellationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.subscriptionControllerAdminDeleteUserSubscriptionCancellationRaw(requestParameters, initOverrides);
    }

    /**
     */
    async subscriptionControllerAdminMakeSubscriptionFreeRaw(requestParameters: SubscriptionControllerAdminMakeSubscriptionFreeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling subscriptionControllerAdminMakeSubscriptionFree().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/subscription/admin/{userId}/turn-to-free`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async subscriptionControllerAdminMakeSubscriptionFree(requestParameters: SubscriptionControllerAdminMakeSubscriptionFreeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.subscriptionControllerAdminMakeSubscriptionFreeRaw(requestParameters, initOverrides);
    }

    /**
     */
    async subscriptionControllerAdminMakeSubscriptionPaidRaw(requestParameters: SubscriptionControllerAdminMakeSubscriptionPaidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling subscriptionControllerAdminMakeSubscriptionPaid().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/subscription/admin/{userId}/turn-to-paid`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async subscriptionControllerAdminMakeSubscriptionPaid(requestParameters: SubscriptionControllerAdminMakeSubscriptionPaidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.subscriptionControllerAdminMakeSubscriptionPaidRaw(requestParameters, initOverrides);
    }

    /**
     */
    async subscriptionControllerAdminRefundInvoiceRaw(requestParameters: SubscriptionControllerAdminRefundInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling subscriptionControllerAdminRefundInvoice().'
            );
        }

        if (requestParameters['invoiceId'] == null) {
            throw new runtime.RequiredError(
                'invoiceId',
                'Required parameter "invoiceId" was null or undefined when calling subscriptionControllerAdminRefundInvoice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/subscription/admin/{userId}/invoice/{invoiceId}/refund`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));
        urlPath = urlPath.replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters['invoiceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async subscriptionControllerAdminRefundInvoice(requestParameters: SubscriptionControllerAdminRefundInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.subscriptionControllerAdminRefundInvoiceRaw(requestParameters, initOverrides);
    }

    /**
     */
    async subscriptionControllerAdminUpdateTrialDaysRaw(requestParameters: SubscriptionControllerAdminUpdateTrialDaysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling subscriptionControllerAdminUpdateTrialDays().'
            );
        }

        if (requestParameters['updateTrialPeriodRequestBody'] == null) {
            throw new runtime.RequiredError(
                'updateTrialPeriodRequestBody',
                'Required parameter "updateTrialPeriodRequestBody" was null or undefined when calling subscriptionControllerAdminUpdateTrialDays().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/subscription/admin/{userId}/trial-period`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateTrialPeriodRequestBodyToJSON(requestParameters['updateTrialPeriodRequestBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async subscriptionControllerAdminUpdateTrialDays(requestParameters: SubscriptionControllerAdminUpdateTrialDaysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.subscriptionControllerAdminUpdateTrialDaysRaw(requestParameters, initOverrides);
    }

    /**
     */
    async subscriptionControllerAdminVoidInvoiceRaw(requestParameters: SubscriptionControllerAdminVoidInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling subscriptionControllerAdminVoidInvoice().'
            );
        }

        if (requestParameters['invoiceId'] == null) {
            throw new runtime.RequiredError(
                'invoiceId',
                'Required parameter "invoiceId" was null or undefined when calling subscriptionControllerAdminVoidInvoice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/subscription/admin/{userId}/invoice/{invoiceId}/void`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));
        urlPath = urlPath.replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters['invoiceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async subscriptionControllerAdminVoidInvoice(requestParameters: SubscriptionControllerAdminVoidInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.subscriptionControllerAdminVoidInvoiceRaw(requestParameters, initOverrides);
    }

    /**
     */
    async subscriptionControllerCancelMyScheduledCancellationRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/subscription/my/cancel-scheduled-cancellation`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async subscriptionControllerCancelMyScheduledCancellation(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.subscriptionControllerCancelMyScheduledCancellationRaw(initOverrides);
    }

    /**
     */
    async subscriptionControllerCancelMySubscriptionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/subscription/my`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async subscriptionControllerCancelMySubscription(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.subscriptionControllerCancelMySubscriptionRaw(initOverrides);
    }

    /**
     */
    async subscriptionControllerDescribeAllOffersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOfferDescriptionResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/subscription/admin/offers/all`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOfferDescriptionResponseFromJSON(jsonValue));
    }

    /**
     */
    async subscriptionControllerDescribeAllOffers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOfferDescriptionResponse> {
        const response = await this.subscriptionControllerDescribeAllOffersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async subscriptionControllerGetJobScheduleRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/subscription/admin/jobs/schedule`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async subscriptionControllerGetJobSchedule(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.subscriptionControllerGetJobScheduleRaw(initOverrides);
    }

    /**
     */
    async subscriptionControllerGetSubscriptionStatusRaw(requestParameters: SubscriptionControllerGetSubscriptionStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSubscriptionStatusResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling subscriptionControllerGetSubscriptionStatus().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['forceRefresh'] != null) {
            queryParameters['forceRefresh'] = requestParameters['forceRefresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/subscription/admin/{userId}/status`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSubscriptionStatusResponseFromJSON(jsonValue));
    }

    /**
     */
    async subscriptionControllerGetSubscriptionStatus(requestParameters: SubscriptionControllerGetSubscriptionStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSubscriptionStatusResponse> {
        const response = await this.subscriptionControllerGetSubscriptionStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async subscriptionControllerGetUserSubscriptionStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSubscriptionStatusResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/subscription/my/status`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSubscriptionStatusResponseFromJSON(jsonValue));
    }

    /**
     */
    async subscriptionControllerGetUserSubscriptionStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSubscriptionStatusResponse> {
        const response = await this.subscriptionControllerGetUserSubscriptionStatusRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async subscriptionControllerLegacyAdminCancelSubscriptionRaw(requestParameters: SubscriptionControllerLegacyAdminCancelSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling subscriptionControllerLegacyAdminCancelSubscription().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/subscription/admin`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async subscriptionControllerLegacyAdminCancelSubscription(requestParameters: SubscriptionControllerLegacyAdminCancelSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.subscriptionControllerLegacyAdminCancelSubscriptionRaw(requestParameters, initOverrides);
    }

    /**
     */
    async subscriptionControllerLegacyGetSubscriptionStatusRaw(requestParameters: SubscriptionControllerLegacyGetSubscriptionStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSubscriptionStatusResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling subscriptionControllerLegacyGetSubscriptionStatus().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['forceRefresh'] != null) {
            queryParameters['forceRefresh'] = requestParameters['forceRefresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/subscription/admin/status`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSubscriptionStatusResponseFromJSON(jsonValue));
    }

    /**
     */
    async subscriptionControllerLegacyGetSubscriptionStatus(requestParameters: SubscriptionControllerLegacyGetSubscriptionStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSubscriptionStatusResponse> {
        const response = await this.subscriptionControllerLegacyGetSubscriptionStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async subscriptionControllerRestoreMySubscriptionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/subscription/my/restore`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async subscriptionControllerRestoreMySubscription(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.subscriptionControllerRestoreMySubscriptionRaw(initOverrides);
    }

    /**
     */
    async subscriptionControllerRunJobRaw(requestParameters: SubscriptionControllerRunJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubscriptionControllerRunJob200Response>> {
        if (requestParameters['jobName'] == null) {
            throw new runtime.RequiredError(
                'jobName',
                'Required parameter "jobName" was null or undefined when calling subscriptionControllerRunJob().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['jobName'] != null) {
            queryParameters['jobName'] = requestParameters['jobName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/subscription/admin/jobs`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubscriptionControllerRunJob200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async subscriptionControllerRunJob(requestParameters: SubscriptionControllerRunJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubscriptionControllerRunJob200Response> {
        const response = await this.subscriptionControllerRunJobRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async subscriptionControllerUpdatePaymentMethodRaw(requestParameters: SubscriptionControllerUpdatePaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['updatePaymentMethodRequest'] == null) {
            throw new runtime.RequiredError(
                'updatePaymentMethodRequest',
                'Required parameter "updatePaymentMethodRequest" was null or undefined when calling subscriptionControllerUpdatePaymentMethod().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/subscription/my/payment-method`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePaymentMethodRequestToJSON(requestParameters['updatePaymentMethodRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async subscriptionControllerUpdatePaymentMethod(requestParameters: SubscriptionControllerUpdatePaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.subscriptionControllerUpdatePaymentMethodRaw(requestParameters, initOverrides);
    }

    /**
     */
    async subscriptionWebHookControllerStripeWebhookRaw(requestParameters: SubscriptionWebHookControllerStripeWebhookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['stripeSignature'] == null) {
            throw new runtime.RequiredError(
                'stripeSignature',
                'Required parameter "stripeSignature" was null or undefined when calling subscriptionWebHookControllerStripeWebhook().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['stripeSignature'] != null) {
            headerParameters['stripe-signature'] = String(requestParameters['stripeSignature']);
        }


        let urlPath = `/subscription/stripe/webhook`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async subscriptionWebHookControllerStripeWebhook(requestParameters: SubscriptionWebHookControllerStripeWebhookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.subscriptionWebHookControllerStripeWebhookRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const SubscriptionControllerRunJobJobNameEnum = {
    SyncSubscriptions: 'sync-subscriptions',
    NotifyTrialAboutToEnd: 'notify-trial-about-to-end',
    NotifyOverdueAfterTrial: 'notify-overdue-after-trial',
    ExpireSubscriptionFlows: 'expire-subscription-flows'
} as const;
export type SubscriptionControllerRunJobJobNameEnum = typeof SubscriptionControllerRunJobJobNameEnum[keyof typeof SubscriptionControllerRunJobJobNameEnum];
